import { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import TextInput from '../TextInput';
import { NewPasswordInputStyle, Toggle } from './styled';

const PasswordInput = ({
  variant,
  placeholder,
  formik,
  name,
  validateWhileTyping,
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <TextInput
      variant={variant}
      placeholder={placeholder}
      type={isVisible ? 'text' : 'password'}
      formik={formik}
      name={name}
      validateWhileTyping={validateWhileTyping}
      {...props}
    >
      {formik?.values?.password && (
        <Toggle variant={variant} onClick={() => setIsVisible(!isVisible)}>
          {isVisible ? 'hide' : 'show'}
        </Toggle>
      )}
    </TextInput>
  );
};

PasswordInput.propTypes = {
  formik: PropTypes.object,
  name: PropTypes.string.isRequired,
  variant: PropTypes.string,
  validateWhileTyping: PropTypes.bool,
  placeholder: PropTypes.string
};

PasswordInput.defaultProps = {
  variant: 'dark',
  placeholder: '•••••••••••••'
};

export const NewPasswordInput = styled(PasswordInput)`
  ${NewPasswordInputStyle}
`;

export default PasswordInput;
